/* ============
 * Mutation types for the assessment module
 * ============
 *
 * The mutation types that are available
 * on the assessment module.
 */
import keyMirror from 'key-mirror';

export default keyMirror({
  FETCH_ASSESSMENTS: null,
  FETCH_ASSESSMENTS_SUCCESS: null,
  FETCH_ASSESSMENTS_FAIL: null,
  FETCH_ASSESSMENT_SYMPTOMS: null,
  FETCH_ASSESSMENT_SYMPTOMS_SUCCESS: null,
  FETCH_ASSESSMENT_SYMPTOMS_FAIL: null
});
